import { defaultFantomProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/fantom/default-constants';

export const SUSHI_SWAP_FANTOM_CONTRACT_ADDRESS = '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506';

export const SUSHI_SWAP_FANTOM_PROVIDER_CONFIGURATION = defaultFantomProviderConfiguration;
